import app from 'flarum/forum/app';
app.initializers.add('val-ui-tag-card-overflow-fade', () => {
  const selector = '.TagsPage .val-tag-tile-main';
  function update(el) {
    const moreBelow = el.scrollHeight - el.scrollTop - el.clientHeight > 3;
    el.classList.toggle('val-has-more-below', moreBelow);
  }
  function wire(el) {
    if (el.dataset.valOverflowFade === '1') {
      update(el);
      return;
    }
    el.dataset.valOverflowFade = '1';
    el.addEventListener('scroll', () => update(el), {
      passive: true
    });
    update(el);
  }
  function scan() {
    document.querySelectorAll(selector).forEach(wire);
  }
  const observer = new MutationObserver(() => {
    requestAnimationFrame(scan);
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  window.addEventListener('resize', scan, {
    passive: true
  });
  requestAnimationFrame(scan);
});